import { apiClient } from './apiClient';
import type { SkillsMatrixVersion, ParsedSkill, ApplySkillsRequest } from './types/skillsMatrix.types';

export async function getSkillsMatrixVersions(): Promise<SkillsMatrixVersion[]> {
  const { data } = await apiClient.get<SkillsMatrixVersion[]>('/skills-matrix/versions');
  return data;
}

export async function parseSkillsMatrix(file: File): Promise<ParsedSkill[]> {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await apiClient.post<ParsedSkill[]>('/skills-matrix/parse', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
}

export async function applySkillsMatrix(request: ApplySkillsRequest): Promise<{ versionId: number; message: string }> {
  const { data } = await apiClient.post<{ versionId: number; message: string }>('/skills-matrix/apply', request);
  return data;
}
